import { assert } from '@ember/debug';
import Service from '@ember/service';
import { tracked } from '@glimmer/tracking';

export default class ModalService extends Service {
  @tracked
  modals: Record<string, HTMLDialogElement> = {};

  register(id: string, element: HTMLDialogElement) {
    this.modals[id] = element;
  }

  unregister(id: string) {
    delete this.modals[id];

    this.modals = { ...this.modals };
  }

  open(id: string) {
    assert(`No modal registered with id ${id}`, this.modals[id]);
    this.modals[id]?.showModal();
  }

  close(id: string) {
    assert(`No modal registered with id ${id}`, this.modals[id]);
    this.modals[id]?.close();
  }
}

// Don't remove this declaration: this is what enables TypeScript to resolve
// this service using `Owner.lookup('service:modal')`, as well
// as to check when you pass the service name as an argument to the decorator,
// like `@service('modal') declare altName: ModalService;`.
declare module '@ember/service' {
  interface Registry {
    modal: ModalService;
  }
}
